import {
  CompensationsSettingsPageDocument,
  UpsertCompensationSettingDocument,
  UpsertCompensationSettingMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

const useUpsertCompensationSetting = () => {
  const [upsertCompensationSetting, { loading }] = useMutation(UpsertCompensationSettingDocument, {
    extractorFn: (data) => data.compensationsMutations.upsertCompensationsCompensationSetting,
    refetchQueries: [CompensationsSettingsPageDocument],
    awaitRefetchQueries: true,
  })

  return {
    loading,
    upsert(variables: UpsertCompensationSettingMutationVariables) {
      return upsertCompensationSetting({
        variables,
      })
    },
  }
}

export default useUpsertCompensationSetting
